import { postmortemSectionTourSteps, tourSteps } from "../constants/tourSteps";

export const getTourSteps = (page) => {
    switch (page) {
        case "/":
          return tourSteps.home;
        case "/ongoing-postmortems":
          return tourSteps.ongoingPostmortems;
        case "/archived-postmortems":
          return tourSteps.archivedPostmortems;
        case "/insights":
          return tourSteps.insights;
        case "/insights-dashboard":
          return tourSteps.insights;
        case "/create":
          return tourSteps.create;
        case "/editpostmortem":

          return tourSteps.editPageSteps
        //   filter(
        //     (step) => document.querySelector(step.selector) !== null
        //   );
        case "/report":
          return tourSteps.report;
        case "/download-report":
          return tourSteps.downloadReport;
       
        default:
          return tourSteps.home;
      }
}

export const getPostmortemSectionTourSteps = (section) => {
  switch (section) {
    case "incidentSummary":
      return postmortemSectionTourSteps.incidentSummary
      break;
  
    default:
      break;
  }
}